


<main *ngIf="multiple">
  <div *ngFor="let item of fileData">









    <div *ngIf="!item.exist">
      <ng-container *ngIf="checkFileSize(item.data)">



        <mat-card class="example-card">
          <mat-card-header>
            <div mat-card-avatar class="example-header-image"></div>
            <mat-card-title>{{item.defaultName}}</mat-card-title>
            <mat-card-subtitle>{{item.data.type}}</mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>
            <h1>{{truncPercent(item.percent)}}%</h1>
            <mat-progress-bar color="accent" mode="buffer" [value]="item.percent"></mat-progress-bar>
          </mat-card-content>

        </mat-card>

        <!--   <p>{{item.data.name}}</p>-->

      </ng-container>
      <ng-container *ngIf="!checkFileSize(item.data)">
        <mat-card class="example-card">
          <mat-card-header>
            <div mat-card-avatar class="example-header-image"></div>
            <mat-card-title>{{item.data.name}}</mat-card-title>
            <mat-card-subtitle>{{item.data.type}}</mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>
            <p>{{'warningFileUpload' | translation}}</p>
          </mat-card-content>

        </mat-card>

      </ng-container>

    </div>


<!--    <div *ngIf="item.exist">
      <div *ngIf="!item.selected">
        <h1>Vous essayez d'importer {{item.data.name}}</h1>
        <p>Un fichier du même nom existe déjà, voulez vous l'utiliser ? Si vous ne le souhaitez pas, merci d'annuler et de renommer votre fichier sous un autre nom.</p>
        <button mat-raised-button color="warn" (click)="setItemData(item, false)">ANNULER</button>
        <button mat-raised-button color="accent" (click)="setItemData(item, true)">UTILISER LE FICHIER EXISTANT</button>
      </div>

      <div *ngIf="item.selected">
        <p>{{item.data.name}}</p>
        <p>Fichier traité</p>
      </div>


    </div>-->


  </div>
        <div *ngIf="showEndButton">
        <button class="card-button" mat-flat-button color="accent" (click)="closeModal()">{{'close' | translation}}</button>
      </div>
  <div >


  </div>
</main>

